import 'bootstrap/dist/css/bootstrap.min.css';
import 'datatables.net';
import 'datatables.net-buttons';
import 'datatables.net-buttons-dt/css/buttons.dataTables.min.css';
import 'datatables.net-buttons/js/buttons.colVis';
import 'datatables.net-buttons/js/buttons.html5';
import 'datatables.net-buttons/js/buttons.print';
import $ from 'jquery';
import React, { useEffect, useRef, useState } from 'react';
import { baseurl } from '../utility/helper';
import Swal from 'sweetalert2';

const TestDeleted = () => {
  const roleid = parseInt(sessionStorage.getItem("userroleId"));
  const [tests, setTests] = useState([]);
  const [selectedTests, setSelectedTests] = useState([]);
  const tableRef = useRef(null);

  const fetchTests = async () => {
    try {
      const token = sessionStorage.getItem("token"); // or sessionStorage, or from state/context
      const response = await fetch(`${baseurl}/admin/deletedtest`, {
        method: 'GET',
        headers: {
          'Authorization': `${token}`, // Ensure token is sent
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await response.json();
      const formattedData = data.map(test => ({
        ...test,
        test_start_time: formatDateTime(test.test_start_time),
        test_end_time: formatDateTime(test.test_end_time),
        register_start_date: formatDateTime(test.register_start_date),
        register_end_date: formatDateTime(test.register_end_date),
      }));
      setTests(formattedData);
    } catch (error) {
      console.error('Error fetching tests:', error);
    }
  };

  useEffect(() => {
    fetchTests();
  }, []);

  useEffect(() => {
    const tableElement = tableRef.current;
  
    if (tableElement) {
      if ($.fn.DataTable.isDataTable(tableElement)) {
        $(tableElement).DataTable().destroy();
      }
  
      const dataTable = $(tableElement).DataTable({
        dom: 'Blfrtip',
        pageLength: 25,
        lengthMenu: [[10, 25, 50, 100, 250, 500, -1], [10, 25, 50, 100, 250, 500, "All"]],
        buttons: [
          { extend: 'copyHtml5', className: 'btn btn-primary dttable', exportOptions: { columns: ':visible' } },
          { extend: 'excelHtml5', className: 'btn btn-primary dttable', exportOptions: { columns: ':visible' } },
          { extend: 'csvHtml5', className: 'btn btn-primary dttable', exportOptions: { columns: ':visible' } },
          { extend: 'pdfHtml5', className: 'btn btn-primary dttable', exportOptions: { columns: ':visible' } },
          { extend: 'print', className: 'btn btn-primary dttable', exportOptions: { columns: ':visible' } },
        ],
        data: tests,
        columns: [
          {
            data: null,
            title: '<input type="checkbox" id="select-all" />',
            orderable: false,
            render: (data, type, row) => `<input type="checkbox" class="row-select" data-id="${row.test_id}" />`,
          },
          { data: null, title: "Sr.No", className: "text-center" },
          { data: 'chapter_id', title: 'Chapter ID' },
          { data: 'test_id', title: 'Test ID' },
          { data: 'test_start_time', title: 'Start Time' },
          { data: 'test_end_time', title: 'End Time' },
          { data: 'test_title', title: 'Title' },
          { data: 'venue', title: 'Venue' },
          { data: 'register_start_date', title: 'Register Start' },
          { data: 'register_end_date', title: 'Register End' },
          { data: null, title: 'Action', orderable: false },
        ],
        columnDefs: [
          {
            targets: 1,
            render: (data, type, row, meta) => meta.row + 1,
          },
          {
            targets: 2,
            render: (data) => `<center>${data}</center>`,
          },
          {
            targets: 3,
            render: (data) => `<center>${data}</center>`,
          },
          {
            targets: 10,
            render: (data, type, row) => {
              const restoreIcon = `<a href="#" class="restore-icon btn btn-warning btn-sm me-2" data-id="${row.test_id}"><i class="fas fa-trash-arrow-up"></i>&nbsp; Restore</a>`;
              const deleteIcon = roleid === 1 ? `<a href="#" class="delete-icon btn btn-danger btn-sm" style="color:white" data-id="${row.test_id}"><i class="fas fa-trash"></i> Delete Forever</a>` : '';
              return `${restoreIcon} ${deleteIcon}`;
            },
          },
        ],
      });
  
      // Select all checkboxes
$(document).on("click", "#select-all", function () {
  const checked = this.checked;

  // Get only visible event IDs
  const visibleTestIds = $(".row-select")
    .map(function () {
      return $(this).data("id");
    })
    .get(); // Convert jQuery object to array

  // Set selected events based on whether "Select All" is checked
  setSelectedTests(checked ? [...new Set(visibleTestIds)] : []);
  
  $(".row-select").each(function () {
    $(this).prop("checked", checked).trigger("change");
  });
});

$(document).on('change', '.row-select', function () {
  const testId = $(this).data('id');
  if (this.checked) {
    // Add the event ID only if it's not already in the selectedEvents
    setSelectedTests((prev) => [...new Set([...prev, testId])]);
  } else {
    // Remove the event ID from selectedEvents
    setSelectedTests((prev) => prev.filter((id) => id !== testId));
  }
});
  
      $(document).on('click', '.delete-icon', async function (e) {
        e.preventDefault();
        if (selectedTests.length === 0) {
          Swal.fire('No Events Selected', 'Please select Events to delete.', 'warning');
          console.log('No Events selected', selectedTests); // Add a log for debugging
          return;
        }
        const result = await Swal.fire({
          title: 'Are you sure?',
          text: 'Do you want to permanently delete the selected Events?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, delete!',
          cancelButtonText: 'Cancel',
        });

        if (result.isConfirmed) {
          try {
            const token = sessionStorage.getItem("token"); // or sessionStorage, or from state/context
            await Promise.all(
              selectedTests.map(testId  =>
                $.ajax({
                  url: `${baseurl}/admin/tests/${testId }?permanentdelete=true`,
                  type: 'DELETE',
                  headers: {
                    Authorization: `${token}`, // Replace 'yourAuthToken' with the actual token
                  },
                })
              )
            );
            Swal.fire('Deleted!', 'Selected Events deleted successfully.', 'success');
            fetchTests(); // Re-fetch the Events after deletion
            setSelectedTests([]); // Clear selected Events
          } catch (error) {
            console.error('Error deleting selected Events:', error);
            Swal.fire('Error', 'Error deleting selected Events.', 'error');
          }
        }
      });


      $(document).on('click', '.restore-icon', async function (e) {
        e.preventDefault();
        const testId  = $(this).data('id');
        const result = await Swal.fire({
          title: 'Are you sure?',
          text: 'Do you want to Restore this test?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, Restore!',
          cancelButtonText: 'Cancel',
        });

        if (result.isConfirmed) {
          try {
            const token = sessionStorage.getItem("token"); // or sessionStorage, or from state/context
            await $.ajax({
              url: `${baseurl}/admin/testsrestore/${testId }`,
              type: 'PUT',
              headers: {
                Authorization: `${token}`, // Replace 'yourAuthToken' with the actual token
              },
            });
            Swal.fire('Restored!', 'Event Restore successfully.', 'success');
            // Re-fetch the Events after deletion
            fetchTests();
          } catch (error) {
            console.error('Error Restore Event:', error);
            Swal.fire('Error', 'Error Restore Event.', 'error');
          }
        }
      });

      $(document).on('click', '.delete-icon', async function (e) {
        e.preventDefault();
        const testId  = $(this).data('id');
        const result = await Swal.fire({
          title: 'Are you sure?',
          text: 'Do you want to permanently delete this Event?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, delete!',
          cancelButtonText: 'Cancel',
        });

        if (result.isConfirmed) {
          try {
            const token = sessionStorage.getItem("token"); // or sessionStorage, or from state/context
            await $.ajax({
              url: `${baseurl}/admin/tests/${testId }?permanentdelete=true`,
              type: 'DELETE',
              headers: {
                Authorization: `${token}`, // Replace 'yourAuthToken' with the actual token
              },
            });
            Swal.fire('Deleted!', 'Event permanently deleted successfully.', 'success');
            // Re-fetch the Events after deletion
            fetchTests();
          } catch (error) {
            console.error('Error deleting Event:', error);
            Swal.fire('Error', 'Error deleting Event.', 'error');
          }
        }
      });

      return () => {
        if ($.fn.DataTable.isDataTable(tableElement)) {
          $(tableElement).DataTable().destroy();
        }
      };
    }
  }, [tests]);
  
  // Function to delete selected events
  const handleDeleteSelected = async () => {
    console.log("Selected Events before deletion:", selectedTests);
  
    if (selectedTests.length === 0) {
      Swal.fire("No Events Selected", "Please select Events to delete.", "warning");
      return;
    }
  
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to permanently delete the selected Events?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete!",
      cancelButtonText: "Cancel",
    });
  
    if (result.isConfirmed) {
      try {
        const token = sessionStorage.getItem("token");
  
        await Promise.all(
          selectedTests.map((testId ) =>
            $.ajax({
              url: `${baseurl}/admin/tests/${testId }?permanentdelete=true`,
              type: "DELETE",
              headers: {
                Authorization: `${token}`,
              },
            }).fail((jqXHR, textStatus, errorThrown) => {
              console.error(`Failed to delete Event ID ${testId }:`, textStatus, errorThrown);
            })
          )
        );
  
        Swal.fire("Deleted!", "Selected Events deleted successfully.", "success");
  
        fetchTests();
        setSelectedTests([]); // **Reset selectedEvents after deletion**
      } catch (error) {
        console.error("Error deleting selected Events:", error);
        Swal.fire("Error", "Error deleting selected Events.", "error");
      }
    }
  };
  

  const formatDateTime = (timestamp) => {
    const date = new Date(timestamp);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  
  return (
    <div className="content container-fluid">
      <center><h1>Test Deleted Entries</h1></center>
      <div className="container mt-4">
        <div className="profile-section">
          <button onClick={handleDeleteSelected} className="btn btn-danger mb-3">Delete Selected List</button>
          <div className="list" style={{ overflow: "auto" }}>
            <div className="row">
              <div className="col-12">
                <table ref={tableRef} className="table table-striped table-bordered" style={{ width: '100%' }}></table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
  
};

export default TestDeleted;
